import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Color from 'color';
import { RESPONSIVE_SIZE } from '../../constants';
import Aspect from '../Aspect';
import ImageLoader from '../ImageLoader';
import Style from '../Style';
import { L1, L2, T1, T2, P1 } from '../Typography';

const FULL_STYLE = {
  position: 'absolute',
  top: 0,
  right: 0,
  bottom: 0,
  left: 0,
};

class ScenePoster extends React.PureComponent {
  static propTypes = {
    responsive: PropTypes.number,
    backgroundColor: PropTypes.string,
    lqip: PropTypes.string,
    thumbnail: PropTypes.string,
    poster: PropTypes.string,
    color: PropTypes.string,
    typeName: PropTypes.string,
    clipCount: PropTypes.number,
    title: PropTypes.string.isRequired,
    description: PropTypes.string,
  };
  static defaultProps = {
    backgroundColor: 'transparent',
    description: '',
  };

  render() {
    const {
      responsive,
      backgroundColor,
      lqip,
      thumbnail,
      poster,
      color,
      typeName,
      clipCount,
      title,
      description,
      ...otherProps
    } = this.props;

    let Title = T2;
    let showDescription = false;
    if (responsive >= RESPONSIVE_SIZE.TABLET_LANDSCAPE) {
      Title = T1;
      showDescription = true;
    }

    return (
      <Aspect ratio={9 / 16}>
        <div
          style={{
            ...FULL_STYLE,
            padding: '1.5vw',
            backgroundColor: Color(Style.Colors.black)
              .alpha(0.75)
              .string(),
            boxShadow: `${color} 1.5vw -1.2vw 0 0`,
          }}
        >
          <div
            style={{
              height: '100%',
              width: '100%',
              position: 'relative',
              color: Style.Colors.white,
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            <ImageLoader
              color={backgroundColor}
              lqip={lqip}
              images={[poster, thumbnail]}
            />
            <div
              style={{
                position: 'relative',
                zIndex: 2,
                width: '80%',
                maxWidth: 'calc(600px + 20%)',
                maxHeight: '90%',
                paddingLeft: '5%',
                paddingBottom: '7%',
              }}
            >
              <div style={{ maxHeight: '100%' }}>
                <L1>
                  {typeName.toUpperCase()}&nbsp;&nbsp;•&nbsp;&nbsp;{clipCount}&nbsp;CLIPS
                </L1>
                <Title>{title.toUpperCase()}</Title>
                {showDescription && (
                  <P1 style={{ maxWidth: '60%' }}>{description}</P1>
                )}
              </div>
            </div>
            <div
              style={{
                position: 'absolute',
                top: 0,
                right: 0,
                left: 0,
                bottom: 0,
                zIndex: 1,
                backgroundColor: Color(Style.Colors.black)
                  .alpha(0.15)
                  .string(),
              }}
            />
          </div>
        </div>
      </Aspect>
    );
  }
}

function mapStateToProps(state) {
  return {
    responsive: state.runtime.responsive,
  };
}

export default connect(mapStateToProps)(ScenePoster);



// WEBPACK FOOTER //
// ./src/components/ScenePoster/ScenePoster.js